// @flow
import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';

import Logo from '../../../assets/images/logo.png';
import styles from './placeholderViews.css';

type PlaceholderViewsPropTypes = {
  title: string,
  subtitle: string,
  image?: string,
  size?: string,
};

const PlaceholderViews = ({
  title = "",
  subtitle = "",
  image,
  size = "medium"
}: PlaceholderViewsPropTypes) => (
  <Grid fluid className={`${styles.container} ${styles[size]}`}>
    <Row center="xs">
      <Col xs={12}>
        <Row center="xs">
          {
            image != null && (
              <div className={`${styles.imageContainer} ${styles[size]}`}>
                <img
                  src={image}
                  alt="Placeholder"
                  className={styles.image}/>
              </div>
            )
          }
        </Row>
        <Row center="xs">
          <Col>
            <div className={`${styles.title} ${styles[size]}`}>
              {title}
            </div>
            <div className={styles.subtitle}>
              {subtitle}
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  </Grid>
);

export default PlaceholderViews;



// WEBPACK FOOTER //
// ./src/scripts/components/PlaceholderViews/index.jsx